module.exports = __webpack_public_path__ + "media/images/Médaille Militaire (Military Medal)  copy-c55bedc4651a9268a8b39a1c4e476a23.jpg";